import { createErrorsStore } from "@/utils/create-errors-store";

export type PaymentMethodsErrorsStoreValues = {
  payment: null | string;
};

const initialErrors: PaymentMethodsErrorsStoreValues = {
  payment: null,
};

export const usePaymentMethodsErrorsStore =
  createErrorsStore<PaymentMethodsErrorsStoreValues>(initialErrors);
